/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} B2b_Deploy_StoreInputs */

const en_b2b_deploy_store = /** @type {(inputs: B2b_Deploy_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch Enterprise Storefront`)
};

const es_b2b_deploy_store = /** @type {(inputs: B2b_Deploy_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanzar Tienda Empresarial`)
};

const fr_b2b_deploy_store = /** @type {(inputs: B2b_Deploy_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancer une vitrine d'entreprise`)
};

const de_b2b_deploy_store = /** @type {(inputs: B2b_Deploy_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enterprise Storefront starten`)
};

const id_b2b_deploy_store = /** @type {(inputs: B2b_Deploy_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luncurkan Etalase Perusahaan`)
};

/** @type {(inputs: B2b_Deploy_StoreInputs) => LocalizedString} */
const ja_b2b_deploy_store = en_b2b_deploy_store;

/** @type {(inputs: B2b_Deploy_StoreInputs) => LocalizedString} */
const zh_b2b_deploy_store = en_b2b_deploy_store;

/** @type {(inputs: B2b_Deploy_StoreInputs) => LocalizedString} */
const ar_b2b_deploy_store = en_b2b_deploy_store;

/** @type {(inputs: B2b_Deploy_StoreInputs) => LocalizedString} */
const it_b2b_deploy_store = en_b2b_deploy_store;

/** @type {(inputs: B2b_Deploy_StoreInputs) => LocalizedString} */
const ru_b2b_deploy_store = en_b2b_deploy_store;

/** @type {(inputs: B2b_Deploy_StoreInputs) => LocalizedString} */
const pt_b2b_deploy_store = en_b2b_deploy_store;

/** @type {(inputs: B2b_Deploy_StoreInputs) => LocalizedString} */
const ko_b2b_deploy_store = en_b2b_deploy_store;

/**
* | output |
* | --- |
* | "Launch Enterprise Storefront" |
*
* @param {B2b_Deploy_StoreInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const b2b_deploy_store = /** @type {((inputs?: B2b_Deploy_StoreInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<B2b_Deploy_StoreInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_b2b_deploy_store(inputs)
	if (locale === "es") return es_b2b_deploy_store(inputs)
	if (locale === "fr") return fr_b2b_deploy_store(inputs)
	if (locale === "de") return de_b2b_deploy_store(inputs)
	if (locale === "ja") return ja_b2b_deploy_store(inputs)
	if (locale === "zh") return zh_b2b_deploy_store(inputs)
	if (locale === "ar") return ar_b2b_deploy_store(inputs)
	if (locale === "id") return id_b2b_deploy_store(inputs)
	if (locale === "it") return it_b2b_deploy_store(inputs)
	if (locale === "ru") return ru_b2b_deploy_store(inputs)
	if (locale === "pt") return pt_b2b_deploy_store(inputs)
	return ko_b2b_deploy_store(inputs)
});